import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Spinner, Alert, Form, Col, InputGroup, Row } from "react-bootstrap";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
import { calculateOODatetime, handleNote } from "./pureFunctions";
registerLocale("de", de);

const minLength = 20;

export default function Eskalationsdatum({
   createOOTask,
   user,
   userlist,
   eskstatus,
   changeEskStatus,
   kachelId,
   sendData,
   notizen,
}) {
   const [edit, setEdit] = useState(false);
   const [isChanged, setIsChanged] = useState(false);
   const [eskText, setEskText] = useState("");
   const [createAufgabe, setCreateAufgabe] = useState(false);
   const [aufgabe, setAufgabe] = useState({ createUser: "", user: "", text: "", type: "", betreff: "", date: "" });
   const [initedatum, setInitEDatum] = useState();

   const [loading, setLoading] = useState("");

   function handleClose() {
      setEdit(false);
      changeEskStatus(kachelId, "eskdatum", initedatum);
   }
   useEffect(() => {
      setInitEDatum(eskstatus["kachel_eskalation_" + kachelId]);
   }, []);

   function changeEskalationsdatum(e) {
      const maxeskalationsdatum = eskstatus["kachel_max_eskalation_" + kachelId];

      if (!maxeskalationsdatum) {
         changeEskStatus(kachelId, "eskdatum", e);
      } else {
         if (new Date(e) < new Date(maxeskalationsdatum)) {
            changeEskStatus(kachelId, "eskdatum", e);
         } else {
            changeEskStatus(kachelId, "eskdatum", maxeskalationsdatum);
         }
      }
   }

   const isWeekend = (date) => {
      const tag = date.getDay();
      return tag === 0 && tag === 6;

      const gesperrteTage = [1, 3]; // Montag und Mittwoch
      const filter = (date) => !gesperrteTage.includes(date.getDay());
   };

   return (
      <>
         <div
            className={
               !eskstatus["kachel_eskalation_" + kachelId]
                  ? "eskalationsdatum"
                  : new Date(eskstatus["kachel_eskalation_" + kachelId]) < new Date()
                    ? "eskalationsdatum eskaliert"
                    : "eskalationsdatum"
            }
            onClick={(e) => {
               e.stopPropagation();
               setEdit(true);
            }}
         >
            {eskstatus["kachel_eskalation_" + kachelId]
               ? new Date(eskstatus["kachel_eskalation_" + kachelId]).toLocaleDateString("de")
               : "--.--.----"}
         </div>
         <Modal
            size="xl"
            show={edit}
            onClick={(e) => {
               e.stopPropagation();
            }}
            onHide={handleClose}
         >
            <Modal.Header closeButton>
               <Modal.Title>Eskalationsdatum</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               {eskstatus["kachel_max_eskalation_" + kachelId] && (
                  <Alert variant="success">
                     <p>
                        Das spätmöglichste Eskalationsdatum ist am{" "}
                        <strong>
                           {new Date(eskstatus["kachel_max_eskalation_" + kachelId]).toLocaleDateString("de")}
                        </strong>
                        .
                     </p>
                     <small>
                        Ein späteres <strong>übergeordnetes Eskalationsdatum</strong> muss vorher von Admin ausgewählt
                        werden.
                     </small>
                  </Alert>
               )}
               <Form>
                  <Form.Group as={Col} controlId={"id_esk_dat"} className="mb-2 mt-2">
                     <Form.Label>Eskalationsdatum</Form.Label>
                     <DatePicker
                        selected={
                           eskstatus["kachel_eskalation_" + kachelId]
                              ? new Date(eskstatus["kachel_eskalation_" + kachelId])
                              : new Date()
                        }
                        onChange={(e) => {
                           changeEskalationsdatum(e);
                        }}
                        maxDate={new Date(eskstatus["kachel_max_eskalation_" + kachelId])}
                        className="bootstrap-datepicker"
                        calendarClassName="custom-date-calendar"
                        timeFormat="HH:mm"
                        dateFormat="dd.MM.yyyy, HH:mm"
                        locale="de"
                        // filterDate={isWeekend}
                        showTimeSelect
                        shouldCloseOnSelect={true}
                        timeIntervals={5}
                     />
                  </Form.Group>
                  <Form.Group className="mb-2 mt-2" as={Col} key={"Esk_kommi"}>
                     <Form.Label>Begründung für die Verschiebung</Form.Label>
                     <InputGroup className="mb-2 mt-2">
                        <Form.Control
                           className={eskText ? "" : "empty-field"}
                           as="textarea"
                           placeholder=""
                           onChange={(e) => {
                              setEskText(e.target.value);
                           }}
                           name={"eskText"}
                           value={eskText}
                           style={{ minHeight: "115px", fieldSizing: "content" }}
                        />
                     </InputGroup>
                     <Form.Text muted>
                        <span className="me-1"> Mindestens {minLength} Zeichen</span>
                        <span
                           style={
                              eskText.length < minLength
                                 ? { backgroundColor: "#b60", color: "#fff", padding: "4px 10px" }
                                 : null
                           }
                        >
                           Aktuell: {eskText.length}
                        </span>
                     </Form.Text>
                  </Form.Group>
               </Form>

               <hr className="mt-3" />
               <Button
                  className="mb-3"
                  variant={createAufgabe ? "secondary" : "dark"}
                  onClick={() => {
                     setCreateAufgabe((prev) => !prev);
                  }}
               >
                  oO-Aufgabe {createAufgabe ? "nicht erstellen" : "erstellen"} (optional)
               </Button>
               {createAufgabe && (
                  <Form>
                     <h4>Aufgabendaten</h4>
                     <Form.Group className="mb-2 mt-2" as={Col} key={"aufgbetreff"}>
                        <Form.Label>Betreff</Form.Label>
                        <InputGroup className="mb-2 mt-2">
                           <Form.Control
                              className={aufgabe.betreff ? "" : "empty-field"}
                              placeholder=""
                              onChange={(e) => setAufgabe((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                              name={"betreff"}
                              value={aufgabe.betreff}
                           />
                        </InputGroup>
                     </Form.Group>
                     <Form.Group className="mb-2 mt-2" as={Col} key={"aufgtext"}>
                        <Form.Label>Beschreibung</Form.Label>
                        <InputGroup className="mb-2 mt-2">
                           <Form.Control
                              className={aufgabe.text ? "" : "empty-field"}
                              as="textarea"
                              placeholder=""
                              onChange={(e) => setAufgabe((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                              name={"text"}
                              value={aufgabe.text}
                              style={{ minHeight: "115px", fieldSizing: "content" }}
                           />
                        </InputGroup>
                     </Form.Group>
                     <Row>
                        <Form.Group as={Col} controlId={"aufpers"} className="mb-2 mt-2">
                           <Form.Label>Für wen ist die Aufgabe?</Form.Label>

                           <Form.Select
                              name={"user"}
                              onChange={(e) => setAufgabe((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                              value={aufgabe.user}
                           >
                              <option value=""></option>
                              <option value={user.Name}>
                                 {user.Vorname} {user.Nachname}
                              </option>
                              {userlist &&
                                 userlist.map((user, index) => {
                                    // console.log(user);
                                    return (
                                       <option key={"selectuser_" + user.Name + "_"} value={user.Name}>
                                          {user.Nachname + " " + user.Vorname}
                                       </option>
                                    );
                                 })}
                           </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId={"id_auf_dat"} className="mb-2 mt-2">
                           <Form.Label>Für wann ist die Aufgabe? (optional)</Form.Label>
                           <DatePicker
                              selected={aufgabe.date ?? new Date()}
                              onChange={(e) => setAufgabe((prev) => ({ ...prev, date: e }))}
                              className="bootstrap-datepicker"
                              calendarClassName="custom-date-calendar"
                              timeFormat="HH:mm"
                              dateFormat="dd.MM.yyyy, HH:mm"
                              locale="de"
                              showTimeSelect
                              shouldCloseOnSelect={true}
                              timeIntervals={5}
                           />
                        </Form.Group>
                     </Row>
                  </Form>
               )}

               {["globaladmin", "admin", "editor", "user"].includes(user.role) && (
                  <div>
                     <hr className="mt-3" />
                     <h5 className="mt-3">Admin: Übergeordnetes Eskalationsdatum</h5>
                     <DatePicker
                        selected={
                           eskstatus["kachel_max_eskalation_" + kachelId]
                              ? new Date(eskstatus["kachel_max_eskalation_" + kachelId])
                              : new Date()
                        }
                        onChange={(e) => {
                           changeEskStatus(kachelId, "maxeskdatum", e);
                        }}
                        className="bootstrap-datepicker"
                        calendarClassName="custom-date-calendar"
                        timeFormat="HH:mm"
                        dateFormat="dd.MM.yyyy, HH:mm"
                        locale="de"
                        showTimeSelect
                        timeIntervals={5}
                     />
                  </div>
               )}
            </Modal.Body>
            <Modal.Footer>
               {loading === "error" && (
                  <Alert key="danger" variant="danger">
                     Fehler!
                  </Alert>
               )}
               {loading === "loading" ? (
                  <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
               ) : (
                  <>
                     <Button variant="secondary" onClick={handleClose}>
                        Abbrechen
                     </Button>
                     <Button
                        variant="primary"
                        disabled={eskText?.length < minLength}
                        onClick={async () => {
                           if (createAufgabe) {
                              await createOOTask("eskalationsänderung", {
                                 Betreff: aufgabe.betreff,
                                 Verantwortung: aufgabe.user,
                                 Bearbeiter: aufgabe.user,
                                 Prio: 3,
                                 Aufgabe: aufgabe.text,
                                 Art: 167, //ToDo
                                 ...(aufgabe.date
                                    ? { Status: 4, Beginnt_am: calculateOODatetime(new Date(aufgabe.date)) }
                                    : { Status: 1 }),
                              });
                           }
                           const updatedNotes = handleNote(notizen, kachelId, {
                              text: eskText,
                              type: { Eskalation: { active: true } },
                              timestamp: new Date().toISOString(),
                              user: user.Name,
                              active: true,
                              bearbeitet: false,
                           });

                           sendData({ currentkachelid: kachelId, postNotes: updatedNotes ?? undefined });
                           // sendData({ currentkachelid: kachelId, postData: updatedBasicData ?? undefined });
                           setEdit(false);
                        }}
                     >
                        Speichern
                     </Button>
                     <Button variant="primary" onClick={() => setEdit(false)}>
                        Schließen
                     </Button>
                  </>
               )}
            </Modal.Footer>
         </Modal>
      </>
   );
}
